import React from "react";
import ConfidenceLabel from "../../shared/ConfidenceLabel";

const TabClinique = ({ form, onChange, getConfidence }) => {
  const gc = getConfidence || (() => ({ exists: false }));
  return (
    <div className="dn-fields">
      <div className="dn-section-label">Constantes</div>
      <div className="dn-row">
        <div className="dn-field-group">
          <label>Poids (kg) <ConfidenceLabel confidence={gc("poids")} /></label>
          <input type="number" step="0.1" placeholder="Ex : 47"
            value={form.poids ?? ""}
            onChange={(e) => onChange("poids", e.target.value)}
            style={{ borderColor: gc("poids").color || undefined }} />
        </div>
        <div className="dn-field-group">
          <label>Taille (m) <ConfidenceLabel confidence={gc("taille")} /></label>
          <input type="number" step="0.01" placeholder="Ex : 1.64"
            value={form.taille ?? ""}
            onChange={(e) => onChange("taille", e.target.value)}
            style={{ borderColor: gc("taille").color || undefined }} />
        </div>
        <div className="dn-field-group">
          <label>PB (cm) <ConfidenceLabel confidence={gc("pb")} /></label>
          <input type="number" step="0.1" placeholder="Ex : 28"
            value={form.pb ?? ""}
            onChange={(e) => onChange("pb", e.target.value)}
            style={{ borderColor: gc("pb").color || undefined }} />
        </div>
      </div>
      <div className="dn-field-group">
        <label>Examen clinique <ConfidenceLabel confidence={gc("examen_clinique")} /></label>
        <textarea rows={6} placeholder="Décrire l'examen clinique..."
          value={form.examen_clinique ?? ""}
          onChange={(e) => onChange("examen_clinique", e.target.value)}
          style={{ borderColor: gc("examen_clinique").color || undefined }} />
      </div>
    </div>
  );
};

export default TabClinique;